import namespace from '@upi/namespace';
import {render} from 'react';
import {notEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';

document.addEventListener( 'DOMContentLoaded', function () {
    const pageData = namespace( 'landingPage' ).VideoHighlightsModel;
    const carouselViewer = document.getElementById( 'carousel-content-viewer' );
    if ( carouselViewer && notEmptyOrNil(pageData) ) {
        const CarouselContentViewer = require( '@components/common/CarouselContentViewer' ).default;
        render( <CarouselContentViewer data={pageData}/>, carouselViewer );
    }
} );
